import { render, staticRenderFns } from "./prd_upload.vue?vue&type=template&id=5cb53fb8&scoped=true"
import script from "./prd_upload.vue?vue&type=script&lang=js"
export * from "./prd_upload.vue?vue&type=script&lang=js"
import style0 from "./prd_upload.vue?vue&type=style&index=0&id=5cb53fb8&prod&scoped=true&lang=less"
import style1 from "./prd_upload.vue?vue&type=style&index=1&id=5cb53fb8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb53fb8",
  null
  
)

export default component.exports